import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-links">
                    <Link to="/" className="footer-link">Home</Link>
                    <Link to="/about" className="footer-link">About</Link>
                    <Link to="/courses" className="footer-link">Courses</Link>
                    <Link to="/pricing" className="footer-link">Pricing</Link>
                    <Link to="/events" className="footer-link">Events</Link>
                    <Link to="/schedule" className="footer-link">Schedule</Link>
                    <Link to="/testimonials" className="footer-link">Testimonials</Link>
                    <Link to="/contact" className="footer-link">Contact</Link>
                </div>
                <p className="copyright">© 2024 Silambam Academy. All rights reserved. Preserving Tamil Martial Heritage.</p>
            </div>
        </footer>
    );
};

export default Footer;
